export default __webpack_public_path__ + "static/media/UsersManagementSelectedIcon.13de1cfe.svg";